import React from 'react';
import './App.css';

import Home from './Components/Home/Home';
import NavBar from './Components/NavBar/NavBar';
import About from './Components/About/About';
import Projects from './Components/Projects/Projects';
import Resources from './Components/Resources/Resources';
import Contact from './Components/Contact/Contact';
import Footer from './Components/Footer/Footer';

function App() {
  return (
    <div className="App">

      <Home />
      <NavBar />
      <About />
      <Projects />
      <Resources />
      <Contact />
      <Footer/>


    </div>
  );
}

export default App;
